export const T = {
  en_GB: {
    description: "Base portfolios of products and weights per risk score and platform",
    noDynamicPortfolios:
      'No dynamic portfolios configured. Click "Add Dynamic Portfolio" to create one.',
    riskScore: "Risk Score",
    platforms: "Platforms",
    weight: "Weight",
    edit: "Edit",
    products: "Products",
    productCount: (count: number) => `${count} product`,
    productCountPlural: (count: number) => `${count} products`,
    actions: "Actions",
    addDynamicPortfolio: "Add Dynamic Portfolio",
    deleteTitle: "Delete Dynamic Portfolio",
    deleteDescription:
      "Are you sure you want to delete this dynamic portfolio and its product weights? This action cannot be undone.",
    delete: "Delete",
    cancel: "Cancel",
    deleted: "Dynamic portfolio deleted",
    error: "Error",
    failedToDelete: "Failed to delete dynamic portfolio",
  },
  nb_NO: {
    description: "Basisporteføljer med produkter og vektinger per risikoscore og plattform",
    noDynamicPortfolios:
      'Ingen dynamiske porteføljer konfigurert. Klikk "Legg til dynamisk portefølje" for å opprette en.',
    riskScore: "Risikoscore",
    platforms: "Plattformer",
    weight: "Vekting",
    edit: "Rediger",
    products: "Produkter",
    productCount: (count: number) => `${count} produkt`,
    productCountPlural: (count: number) => `${count} produkter`,
    actions: "Handlinger",
    addDynamicPortfolio: "Legg til dynamisk portefølje",
    deleteTitle: "Slett dynamisk portefølje",
    deleteDescription:
      "Er du sikker på at du vil slette denne dynamiske porteføljen og dens produktvektinger? Denne handlingen kan ikke angres.",
    delete: "Slett",
    cancel: "Avbryt",
    deleted: "Dynamisk portefølje slettet",
    error: "Feil",
    failedToDelete: "Kunne ikke slette dynamisk portefølje",
  },
} as const;
